<app-header></app-header>

<main class="container mx-auto py-2">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
